export const buildPermissionGraph = (groups) => {
  const permissionById = {};

  groups.forEach((group) => {
    group.permissions.forEach((permission) => {
      permissionById[permission.id] = permission;
    });
  });

  const dependentsOf = {};
  Object.keys(permissionById).forEach((id) => {
    dependentsOf[id] = [];
  });

  Object.values(permissionById).forEach((permission) => {
    (permission.requires || []).forEach((requiredId) => {
      if (dependentsOf[requiredId])
        dependentsOf[requiredId].push(permission.id);
    });
  });

  return { permissionById, dependentsOf };
};
